import {
  ReportsSettingsModalController
} from './reports-settings.component';

export class ReportsSettingsModalService {
  constructor($timeout, $modal, $http, ) {
    this.$timeout = $timeout;
    this.$modal = $modal;
    this.$http = $http;
    this.data = {};
  }


  getReportList() {
    return this.$http.get('/analytics/obtain_reports_list/');
  }

  open(report='') {
    this.getReportList()
      .then(({
        data,
        status
      }) => {
        this.data = Object.assign(data, {
          report: report
        });
        return this.$modal.open({
          template: require('./reports-settings.component.html'),
          controller: ReportsSettingsModalController,
          resolve: {
            data: () => this.data,
          },
        }).result.then(
          () => null,
          () => null,
        );
      });
  }
}



// WEBPACK FOOTER //
// ./src/core/reports-settings/reports-settings.service.js